export default {
  // 风险类型
  质量风险: "质量风险",
  交付风险: "交付风险",
  财务风险: "财务风险",
  成本风险: "成本风险",
  注册风险: "注册风险",
  其他风险: "其他风险",

  // 风险等级
  高: "高",
  中: "中",
  低: "低",

  // Modal 标题
  通知供应商风险: "通知供应商风险",
  查看供应商风险: "查看供应商风险",
  编辑供应商风险: "编辑供应商风险",
  登记供应商风险: "登记供应商风险",

  // 表格列标题
  处理状态: "处理状态",
  供应商编号: "供应商编号",
  "供应商名称（中文）": "供应商名称（中文）",
  "供应商名称（英文）": "供应商名称（英文）",
  物料类别: "物料类别",
  风险等级: "风险等级",
  发起人: "发起人",
  发起部门: "发起部门",
  发起日期: "发起日期",
  操作: "操作",

  // 状态值
  未知: "未知",

  // 操作按钮
  编辑: "编辑",
  删除: "删除",
  查看: "查看",
  通知供应商: "通知供应商",

  // 确认对话框
  删除确认: "删除确认",
  "确定要删除此风险等级吗？": "确定要删除此风险等级吗？",
  确定: "确定",
  取消: "取消",
  点击上传: "点击上传",

  // 搜索字段
  供应商: "供应商",
  物料: "物料",
  请输入供应商名称: "请输入供应商名称",
  请输入物料名称: "请输入物料名称",
  请选择处理状态: "请选择处理状态",
  请选择发起人: "请选择发起人",

  // 物料类别选项
  电子元器件: "电子元器件",
  机械零件: "机械零件",
  化工原料: "化工原料",
  其他: "其他",

  // 风险类型选项（搜索）
  交期风险: "交期风险",
  价格风险: "价格风险",
  信用风险: "信用风险",

  // 处理状态选项
  草稿: "草稿",
  待通知供应商: "待通知供应商",
  待供应商提供解决方案: "待供应商提供解决方案",
  解决方案审批中: "解决方案审批中",
  已驳回解决方案: "已驳回解决方案",
  已完结: "已完结",

  // 列表标题和按钮
  供应商风险等级列表: "供应商风险等级列表",

  // 分页
  共数据条: "共 {{totalCount}} 条数据",

  // 表单标签
  员工姓名: "员工姓名",
  员工工号: "员工工号",
  创建日期: "创建日期",
  部门: "部门",
  岗位: "岗位",
  邮箱: "邮箱",
  供应商信息: "供应商信息",
  请输入供应商编号搜索: "请输入供应商编号搜索",
  供应商名称中文: "供应商名称中文",
  供应商名称英文: "供应商名称英文",
  二级物料类别: "二级物料类别",
  物料编号: "物料编号",
  请输入物料编号搜索: "请输入物料编号搜索",
  物料名称: "物料名称",
  风险类型: "风险类型",
  风险等级评估: "风险等级评估",
  发现日期: "发现日期",
  期望解决日期: "期望解决日期",
  风险描述: "风险描述",
  相关证明文件: "相关证明文件",
  供应商解决方案: "供应商解决方案",
  备注说明: "备注说明",
  评估信息: "评估信息",
  评估意见: "评估意见",
  意见说明: "意见说明",
  同意: "同意",
  驳回: "驳回",
  由供应商编号自动填写: "由供应商编号自动填写",

  // 表单占位符
  请输入员工姓名: "请输入员工姓名",
  请输入员工工号: "请输入员工工号",
  请输入创建日期: "请输入创建日期",
  请输入部门: "请输入部门",
  请输入岗位: "请输入岗位",
  请输入邮箱: "请输入邮箱",
  请选择物料类别: "请选择物料类别",
  请选择二级物料类别: "请选择二级物料类别",
  请选择风险类型: "请选择风险类型",
  请选择风险等级评估: "请选择风险等级评估",
  请选择发现日期: "请选择发现日期",
  请选择期望解决日期: "请选择期望解决日期",
  请输入风险描述: "请输入风险描述",
  请上传相关证明文件: "请上传相关证明文件",
  请输入备注说明: "请输入备注说明",
  请选择评估意见: "请选择评估意见",
  请输入意见说明: "请输入意见说明",

  // 表单验证消息
  供应商编号必填: "供应商编号必填",
  供应商名称中文必填: "供应商名称中文必填",
  供应商名称英文必填: "供应商名称英文必填",
  物料类别必填: "物料类别必填",
  二级物料类别必填: "二级物料类别必填",
  物料名称必填: "物料名称必填",
  风险类型必填: "风险类型必填",
  风险等级评估必填: "风险等级评估必填",
  发现日期必填: "发现日期必填",
  期望解决日期必填: "期望解决日期必填",
  风险描述必填: "风险描述必填",
  相关证明文件必填: "相关证明文件必填",

  // 消息提示
  生成失败: "生成失败",
  提交成功: "提交成功",
  提交失败: "提交失败",
  已暂存: "已暂存",
  暂存失败: "暂存失败",
  表单数据获取失败: "表单数据获取失败",
  已通知供应商: "已通知供应商",
  任务ID不存在无法通知供应商: "任务ID不存在无法通知供应商",
  通知供应商失败: "通知供应商失败",
  加载风险登记详情失败: "加载风险登记详情失败",
  删除成功: "删除成功",

  // 文件相关
  暂无解决方案文件: "暂无解决方案文件",

  // 数据加载错误
  获取物料数据失败: "获取物料数据失败",
  获取供应商数据失败: "获取供应商数据失败",

  // 其他
  单号: "单号",
  加载中: "加载中",

  searchFields: {
    supplier: "供应商",
    material: "物料",
    materialCategory: "物料类别",
    materialName: "物料名称",
    riskType: "风险类型",
    processingStatus: "处理状态",
    initiator: "发起人",
    supplierNameP: "请输入供应商名称",
    materialNameP: "请输入物料名称",
    materialCategoryP: "请选择物料类别",
    riskTypeP: "请选择风险类型",
    processingStatusP: "请选择处理状态",
    initiatorP: "请选择发起人",
  },
};
